export const Tags = {
  _321: '321',
  _No321: 'No321',
  dutyPay: 'DUTY_PAY',
  international: 'INTERNATIONAL',
  noTags: 'NO_TAGS',
  external: 'EXTERNAL',
};
